import { useCreateProposalStore } from '../../../Stores/useCreateProposalStore'
import { useFirstReceiptInfo } from '../../../Stores/useFirstReceiptInfo'

export const useRefreshFirstReceiptStatusPayload = () => {
  const { createProposal } = useCreateProposalStore()
  const { firstReceiptInfo } = useFirstReceiptInfo()

  const payload = {
    invoiceId: firstReceiptInfo?.invoiceId || '',
    policyId: createProposal?.createProposalResponse?.proposalId || '',
  }

  return {
    payload,
  }
}
